import { useId } from "react";

/**
 * @description
 * Generate a unique array list.
 * @param count
 */
function generateIds(count: number) {
  return Array.from({ length: count }, () => useId());
}

export default generateIds;
